export { default } from "./PropertyManager";
